import React from 'react';

export default function ErrorPage() {
    return (
        <div className="maincontainer">
            <style jsx>
                {`
                    body {
                        background-color: #f2f2f2;
                        margin: 0;
                    }

                    .container {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        width: 300px;
                        height: calc(100vh - 104px);
                        margin: 0px auto;
                    }

                    .error-description {
                        font-size: 30px;
                        font-family: "Open Sans", sans-serif;
                        color: #353535;
                        font-weight: 200;
                        line-height: normal;
                        text-align: center;
                        margin: 25px 0 0 0;
                    }

                    .error-image {
                        width: 100%;
                        height: auto;
                    }

                    img {
                        margin-top: -1px;
                        width: inherit;
                        height: inherit;
                    }

                    @media screen and (min-width: 768px) {
                        .container {
                            flex-direction: row-reverse;
                            width: auto;
                            max-width: 1140px;
                            height: calc(100vh - 56px);
                            padding: 0 40px;
                        }

                        .error-image {
                            width: 40%;
                            margin-left: 100px;
                            margin-right: 0;
                        }

                        .error-description {
                            width: 375px;
                            font-size: 45px;
                            text-align: left;
                        }
                    }

                    .jpCAAw {
                        height: auto;
                        margin-top: 18px;
                        padding-left: 24px;
                    }

                    @media screen and (min-width: 905px) {
                        .jpCAAw {
                            margin-top: 22px;
                        }
                    }

                    .jpCAAw svg {
                        display: block;
                    }

                    .gVOJxh {
                        height: auto;
                        margin-top: 21px;
                        padding-left: 11px;
                    }

                    @media screen and (min-width: 576px) {
                        .gVOJxh {
                            padding-left: 24px;
                        }
                    }

                    .gVOJxh svg {
                        display: block;
                    }

                    .dgXCbN {
                        font-family: "Open Sans", sans-serif;
                    }

                    .jmKFti {
                        background-color: #7d268b;
                        height: 56px;
                        position: fixed;
                        top: 0px;
                        width: 100%;
                    }

                    @media screen and (min-width: 768px) {
                        .jmKFti {
                            height: 68px;
                        }
                    }

                    .dbesTy {
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        font-family: "Open Sans", sans-serif;
                        margin-left: 0px;
                        margin-right: 9px;
                        max-width: 1185px;
                    }

                    @media screen and (min-width: 768px) {
                        .dbesTy {
                            margin-left: auto;
                            margin-right: 19px;
                        }
                    }

                    @media screen and (min-width: 992px) {
                        .dbesTy {
                            margin-right: auto;
                        }
                    }

                    .lmnwvR {
                        display: none;
                    }

                    @media screen and (min-width: 992px) {
                        .lmnwvR {
                            display: block;
                        }
                    }

                    .gYxvIP {
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-flex-direction: row;
                        -ms-flex-direction: row;
                        flex-direction: row;
                        width: 100%;
                    }

                    @media screen and (min-width: 768px) {
                        .gYxvIP {
                            width: initial;
                        }
                    }

                    @media screen and (min-width: 992px) {
                        .gYxvIP {
                            display: none;
                        }
                    }

                    .Fwcpf {
                        width: 50px;
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-pack: end;
                        -webkit-justify-content: flex-end;
                        -ms-flex-pack: end;
                        justify-content: flex-end;
                    }

                    .eysfBO {
                        background-color: #982ea9;
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -ms-flexbox;
                        display: flex;
                        position: fixed;
                        top: 56px;
                        width: 100%;
                    }

                    @media screen and (min-width: 768px) {
                        .eysfBO {
                            display: none;
                        }
                    }

                    .ibaoyu {
                        display: none;
                        font-family: "Open Sans", sans-serif;
                        font-size: 16px;
                        font-weight: 400;
                        margin-bottom: 21px;
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 21px;
                    }

                    @media screen and (min-width: 768px) {
                        .ibaoyu {
                            display: block;
                        }
                    }

                    .bUUeTB {
                        display: none;
                        font-family: "Open Sans", sans-serif;
                        font-size: 16px;
                        font-weight: 400;
                        margin-bottom: 21px;
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 21px;
                    }

                    @media screen and (min-width: 992px) {
                        .bUUeTB {
                            display: block;
                        }
                    }

                    .elQhkq {
                        display: none;
                        font-family: "Open Sans", sans-serif;
                        font-size: 16px;
                        font-weight: 400;
                        margin-bottom: 21px;
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 21px;
                    }

                    .jbOdwd {
                        display: block;
                        font-family: "Open Sans", sans-serif;
                        font-size: 16px;
                        font-weight: 400;
                        margin-bottom: 10px;
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 10px;
                    }

                    .eVzEEJ {
                        -webkit-text-decoration: none;
                        text-decoration: none;
                        color: white !important;
                        opacity: 1;
                        -webkit-transition: none;
                        transition: none;
                        -webkit-transition-delay: 0.4s;
                        transition-delay: 0.4s;
                        height: 26px;
                        line-height: 26px;
                        -webkit-box-pack: center;
                        -webkit-justify-content: center;
                        -ms-flex-pack: center;
                        justify-content: center;
                    }

                    .eVzEEJ:hover {
                        text-shadow: 0 0 0.65px #fff, 0 0 0.65px #fff;
                    }

                    .jdWPfk .fg-logo:hover {
                        opacity: 1 !important;
                    }

                    .jFdNvB:hover {
                        -webkit-text-decoration: none;
                        text-decoration: none;
                        opacity: 1 !important;
                    }

                    .dweUkW {
                        font-family: "Open Sans", sans-serif;
                    }
                `}
            </style>
            <div fontFamily="Open Sans" className="View__Styled-kNNgRd dgXCbN">
                <div className="View__Styled-sc-tbps05-0 Headerstories___StyledView-fBYWWA dweUkW">
                    <div
                        width="100%"
                        height="[object Object]"
                        className="View__Styled-kNNgRd jmKFti"
                    >
                        <div
                            display="flex"
                            fontFamily="Open Sans"
                            className="View__Styled-kNNgRd dbesTy Header___StyledView-LGDsN jdWPfk"
                        >
                            <a
                                href="/"
                                className="View__Styled-kNNgRd lmnwvR fg-logo"
                            >
                                <div
                                    height="32px"
                                    className="Icon__Styled-dKPIfv jpCAAw"
                                >
                                    <svg
                                        width="204"
                                        height="33"
                                        viewBox="0 0 204 33"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M26.0825 0.631348V31.4923H30.6556V18.2687H36.9255V13.8549H30.6556V5.00951H37.9435V0.631348H26.0825Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M48.2154 20.5468L46.4701 7.69697L44.7249 20.5468H48.2154ZM52.837 20.5468L54.3236 31.4923H49.702L48.8133 24.9429H44.1432L43.2382 31.4923H38.6328L40.1195 20.5824L43.3514 0.631348H49.6212L52.837 20.5468Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M56.2251 31.4923H60.7982V0.631348H56.2251V31.4923Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M68.7264 5.00955V13.8549H69.7768C70.4123 13.8549 70.8486 13.8136 71.0857 13.7303C71.9151 13.41 72.33 12.7515 72.33 11.7548V7.12748C72.33 5.71565 71.6674 5.00955 70.3423 5.00955H68.7264ZM64.1533 0.631348H70.811C74.8723 0.631348 76.9031 2.79683 76.9031 7.1275V11.7549C76.9031 14.4721 75.7017 16.2637 73.2995 17.1297L78.4382 31.4923H73.4288L69.3082 17.9128L68.7264 18.0018V31.4923H64.1533V0.631348Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M82.2301 0.631348L85.3489 12.6625L88.4676 0.631348H93.3155L87.7728 18.1263L87.6435 18.5179V31.4923H83.0704V18.5179L82.925 18.1263L77.3823 0.631348H82.2301Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M107.95 25.4744C107.95 29.8127 105.709 31.9875 101.229 31.9995C96.7603 31.9995 94.5259 29.8247 94.5259 25.4744V6.50682C94.5259 2.16882 96.7603 -0.000488281 101.229 -0.000488281C105.709 -0.000488281 107.95 2.16882 107.95 6.50682V10.6722H103.277V6.50682C103.277 5.11241 102.6 4.41517 101.246 4.41517H101.213C99.8699 4.41517 99.1986 5.11241 99.1986 6.50682V25.4744C99.1986 26.8688 99.8756 27.566 101.229 27.566C102.594 27.566 103.277 26.8688 103.277 25.4744V18.1984H101.246V13.7827H107.95V25.4744Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M119.33 6.67073C119.33 5.28529 118.653 4.59254 117.299 4.59254H117.266C115.923 4.59254 115.252 5.28529 115.252 6.67073V25.5164C115.252 26.9018 115.929 27.5946 117.283 27.5946C118.647 27.5946 119.33 26.9018 119.33 25.5164V6.67073ZM124.003 25.5164C124.003 29.8268 121.763 31.9876 117.283 31.9996C112.814 31.9996 110.579 29.8387 110.579 25.5164V6.67074C110.579 2.36062 112.814 0.205322 117.283 0.205322C121.763 0.205322 124.003 2.36062 124.003 6.67074V25.5164Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M166.926 6.84536C166.926 5.46608 166.264 4.7764 164.939 4.7764H164.906C163.592 4.7764 162.935 5.46608 162.935 6.84536V25.6072C162.935 26.9864 163.597 27.6761 164.922 27.6761C166.258 27.6761 166.926 26.9864 166.926 25.6072V6.84536ZM171.712 25.5164C171.712 29.8268 169.472 31.9876 164.992 31.9996C160.523 31.9996 158.289 29.8387 158.289 25.5164V6.67074C158.289 2.36062 160.523 0.205322 164.992 0.205322C169.472 0.205322 171.712 2.36062 171.712 6.67074V25.5164Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M131.242 5.00955V27.0963H133.245C134.57 27.0963 135.233 26.4022 135.233 25.014V7.12748C135.233 5.71565 134.57 5.00955 133.245 5.00955H131.242ZM126.668 0.631348H133.714C137.775 0.631348 139.806 2.79683 139.806 7.1275V25.014C139.806 29.321 137.678 31.4807 133.423 31.4923H126.668V0.631348Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M147.33 18.2687V27.0963H149.334C150.659 27.0963 151.322 26.4022 151.322 25.014V20.351C151.322 19.3664 150.907 18.7198 150.078 18.4111C149.84 18.3163 149.404 18.2687 148.769 18.2687H147.33ZM147.33 5.00955V13.8549H148.769C149.404 13.8549 149.84 13.8135 150.078 13.7303C150.907 13.41 151.322 12.7515 151.322 11.7548V7.12748C151.322 5.71565 150.659 5.00955 149.334 5.00955H147.33ZM142.757 0.631348H149.803C153.864 0.631348 155.895 2.79683 155.895 7.1275V11.7549C155.895 13.7837 155.06 15.2196 153.39 16.0618C155.06 16.9045 155.895 18.3341 155.895 20.3511V25.014C155.895 29.321 153.767 31.4807 149.512 31.4923H142.757V0.631348Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M189.894 6.68264C189.894 2.36394 192.081 0.204346 196.455 0.204346C200.839 0.204346 203.032 2.36394 203.032 6.68264V10.8295H198.459V6.68264C198.459 5.29444 197.796 4.6003 196.471 4.6003H196.439C195.124 4.6003 194.467 5.29444 194.467 6.68264V9.47685C194.467 10.8534 195.894 12.538 198.749 14.5314C201.604 16.513 203.032 18.8918 203.032 21.6682V25.5658C203.032 29.8968 200.845 32.062 196.471 32.062C192.086 32.05 189.894 29.8848 189.894 25.5658V21.419H194.467V25.5658C194.467 26.954 195.135 27.6482 196.471 27.6482C197.796 27.6482 198.459 26.954 198.459 25.5658V22.042C198.459 20.5469 197.031 18.8028 194.176 16.8094C191.321 14.8281 189.894 12.4196 189.894 9.58362V6.68264Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M174.128 6.68264C174.128 2.36394 176.315 0.204346 180.689 0.204346C185.073 0.204346 187.266 2.36394 187.266 6.68264V10.8295H182.692V6.68264C182.692 5.29444 182.03 4.6003 180.705 4.6003H180.673C179.358 4.6003 178.701 5.29444 178.701 6.68264V9.47685C178.701 10.8534 180.128 12.538 182.983 14.5314C185.838 16.513 187.266 18.8918 187.266 21.6682V25.5658C187.266 29.8968 185.078 32.062 180.705 32.062C176.32 32.05 174.128 29.8848 174.128 25.5658V21.419H178.701V25.5658C178.701 26.954 179.369 27.6482 180.705 27.6482C182.03 27.6482 182.692 26.954 182.692 25.5658V22.042C182.692 20.5469 181.265 18.8028 178.41 16.8094C175.555 14.8281 174.128 12.4196 174.128 9.58362V6.68264Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12.2241 4.77984C12.2097 4.77428 12.0669 4.69552 12.0485 4.70421C12.0222 4.71673 11.9875 4.78206 11.9708 4.80512C11.9105 4.88824 11.8723 4.96711 11.818 5.05282C11.8032 5.07618 11.7876 5.09897 11.7705 5.12078C11.7597 5.13443 11.7453 5.16264 11.7263 5.1655C11.7102 5.16798 11.7027 5.15185 11.6943 5.14011C11.6225 5.03879 11.5636 4.94172 11.5528 4.81625C11.548 4.75904 11.5465 4.7015 11.5487 4.64422C11.5525 4.54425 11.5651 4.4453 11.5829 4.34687C11.586 4.32912 11.6131 4.14351 11.6283 4.14366C11.7687 4.14584 11.8628 4.10289 11.9046 4.00913C11.9565 4.24258 11.9954 4.48878 12.227 4.54726C12.227 4.6071 12.2241 4.72008 12.2241 4.77984ZM7.31143 18.6451L6.12833 17.7323C6.14723 17.5235 6.27925 17.2593 6.56712 17.2421C6.3993 17.5819 6.64256 17.6272 6.7236 17.6416C6.73045 17.8129 6.80008 17.8916 6.9373 17.8712C6.97714 17.9808 6.97025 18.1482 7.22403 18.077C7.23325 18.347 7.41495 18.3044 7.57753 18.247C7.67521 18.397 7.49023 18.6084 7.31143 18.6451ZM21.3361 15.6141C21.3177 15.5865 21.277 15.5247 21.2571 15.4965C21.2138 15.4352 21.1681 15.3755 21.1245 15.3142C21.0834 15.2564 21.0512 15.1888 21.0064 15.1343C20.9764 15.0979 20.9457 15.0623 20.9146 15.0269C20.9037 15.0146 20.8932 15.0015 20.8813 14.9901C20.8055 14.9166 20.7231 14.8493 20.6295 14.7998C20.3514 14.653 19.9945 14.6482 19.7326 14.5152C19.3775 14.335 18.9964 13.9456 18.7412 13.7088C18.4457 13.4346 18.0993 13.1528 17.8443 12.9024C17.6716 12.7327 17.5152 12.5471 17.3419 12.3782C17.2311 12.2702 17.111 12.1725 17.0021 12.0627C16.8943 11.9538 16.8033 11.8296 16.6951 11.721C16.6246 11.6502 16.547 11.5908 16.4598 11.5424C16.3977 11.5078 16.385 11.4376 16.3492 11.382C16.3165 11.3312 16.2798 11.2836 16.2393 11.2389C16.1675 11.1593 16.0554 11.0916 16.0004 10.9997C15.8374 10.7275 15.7225 10.4305 15.5439 10.166C15.5195 10.1299 15.4941 10.0942 15.4678 10.0594C15.4554 10.0427 15.3888 9.97961 15.3895 9.96131C15.4022 9.65632 15.1774 9.45827 15.1063 9.15484C15.0791 9.03859 15.1354 8.87961 15.1063 8.72795C15.0765 8.57283 14.9384 8.44031 14.9175 8.30103C14.8839 8.07812 14.9561 7.86555 14.8855 7.64478C14.8189 7.43667 14.6953 7.25016 14.549 7.08995C14.479 7.01333 14.4411 6.97307 14.3509 6.92533C13.9387 6.70703 13.868 6.14559 13.5956 5.78682C13.7884 5.30853 13.9142 4.92115 14.1818 4.63256C14.4257 4.60093 14.8387 4.69979 15.0119 4.45858C15.0886 4.27875 14.9647 4.16135 14.9647 4.03165C14.9754 3.82748 15.0844 3.69432 14.9647 3.55726C14.9555 3.54672 15.0359 3.47392 15.0451 3.46727C15.1057 3.42339 15.1847 3.39757 15.225 3.32902C15.2826 3.23107 15.2157 3.16591 15.1529 3.0974C15.0863 3.02483 15.0148 2.96547 14.9543 2.88757C14.9233 2.84767 14.8958 2.80494 14.8738 2.75943C14.8556 2.72207 14.8203 2.65157 14.8231 2.60857C14.8427 2.2963 15.0176 2.28464 15.0119 2.03933C15.0095 1.93538 14.97 1.81495 14.9242 1.72297C14.8256 1.52544 14.6449 1.36539 14.4707 1.23573C14.2844 1.097 14.0579 0.994319 13.8299 0.94797C13.5183 0.884713 13.2016 0.81326 12.8817 0.827543C12.4332 0.847435 12.0523 1.08483 11.7749 1.43095C11.5244 1.74358 11.3853 2.15932 11.3769 2.5611C11.3694 2.91809 11.5152 3.1971 11.4714 3.46242C11.3789 3.46644 11.2274 3.62251 11.3297 3.79446C10.3755 3.91282 10.8449 5.27249 11.2825 5.69197C11.0198 5.9814 10.7867 6.30055 10.5272 6.59325C8.30363 4.82718 6.40691 2.73258 5.1456 -0.000488281C5.10625 0.52928 5.266 1.1673 5.43672 1.61237C5.1376 1.48605 4.94495 1.15389 4.86232 0.853403C4.63808 2.06698 5.65305 3.04735 5.36391 3.23115C5.18096 3.17382 4.93711 2.86355 4.83089 2.72716C4.53977 4.56138 5.52441 4.80196 5.47603 5.92917C5.42334 6.12662 5.16916 5.99437 5.04528 6.02994C5.39907 6.76547 5.95636 7.34402 6.75061 7.63687C6.44793 7.94945 6.16053 8.11126 5.38755 8.08162C6.08666 8.97609 7.45209 9.2247 8.35565 9.91384C7.53785 10.0431 6.75849 10.3882 5.76715 10.1826C6.16057 10.9337 7.24633 11.0207 8.19047 11.0286C8.20619 11.1076 7.53741 11.6611 6.80572 11.6453C7.26597 11.9833 7.71051 12.1117 8.27698 12.175C8.11767 12.9091 7.72591 13.7211 7.50593 14.5152C7.39381 14.9199 7.39456 15.3454 7.31708 15.7249C7.21482 16.2261 6.89179 16.4837 6.70341 16.8396C6.51915 16.7634 6.27012 16.8288 6.1251 16.9266C5.93937 17.0518 5.77111 17.1885 5.74154 17.4297L5.43636 17.1911L5.00984 16.7448L4.88315 16.7585L4.31944 16.3178L4.31992 16.3202L3.86509 15.9621L3.1452 15.9206L2.91062 16.2861C1.92712 17.7566 0.963026 19.1789 0 20.682L0.447187 21.044L0.392788 21.1119L0.524708 21.2186L0.578948 21.1507L0.637306 21.1979C2.25605 22.5124 3.94764 23.7833 5.57042 25.0936L5.58863 25.11L5.52992 25.1782L5.65792 25.2894L5.71469 25.2234L6.131 25.5977C6.20919 25.5413 6.31249 25.4731 6.36704 25.4376C6.46586 25.4302 6.5382 25.4316 6.75061 25.4257C6.76898 25.4252 6.89915 25.2066 6.91602 25.1818C6.97236 25.0995 7.02905 25.0173 7.08539 24.935C7.19613 24.7733 7.30465 24.6101 7.41491 24.4482C7.63005 24.1321 7.84298 23.8143 8.06057 23.5C8.27579 23.1893 8.48713 22.8757 8.70097 22.564C8.91884 22.2464 9.14499 21.9318 9.35391 21.6082C9.48365 21.4073 9.64634 21.2252 9.76432 21.0173C9.81927 20.9207 9.88903 20.7916 9.83907 20.6862C9.78368 20.5694 9.6638 20.5055 9.56616 20.4197C9.56616 20.4197 9.02217 19.9944 9.02245 19.9942L8.45008 19.3953L8.27952 19.4138L7.58472 18.8706C7.93879 18.7681 8.16684 18.1876 7.99374 17.8358C8.11173 17.4919 8.12055 17.2601 8.14324 16.9879C8.18616 16.4722 8.11371 15.9561 8.27892 15.7486C8.49137 15.7723 8.82774 15.7782 9.11094 15.796C9.38832 14.5152 9.80573 13.5847 10.2203 12.4992C10.4505 12.3865 10.6806 12.2976 10.7869 12.256C10.8367 13.4957 10.3849 14.4404 10.2439 15.3691C10.1232 16.1645 10.1274 17.1702 10.0079 17.9307C10.1256 18.018 10.3059 18.0344 10.4387 18.0612C10.4798 18.9555 10.1623 19.9248 10.0079 20.7769C10.2474 20.7962 10.2589 20.5863 10.4327 20.5397C10.6753 22.1013 9.24215 23.1281 9.11094 25.0936C9.03564 26.2222 9.13347 27.2992 9.01655 28.3193C8.94834 28.9144 8.68173 29.2708 8.49727 29.6002C8.21522 30.1037 8.39698 30.205 8.21407 31.5451C8.50317 31.5866 8.75648 31.6641 9.06379 31.6874C9.09471 31.3864 9.07558 31.0114 9.11094 30.7386C9.82822 30.8249 10.1972 31.6672 10.9993 31.7823C11.2195 31.8139 11.5517 31.7982 11.8018 31.7823C12.0589 31.7659 12.3375 31.7808 12.5756 31.6624C12.9409 31.4808 12.2824 31.2466 12.1492 31.2019C12.0408 31.1655 11.931 31.1334 11.8208 31.103C11.7308 31.0782 11.5992 31.0693 11.5185 31.0232C11.275 30.8844 11.1956 30.6055 10.9993 30.3117C10.8367 30.0685 10.6055 29.865 10.5272 29.695C9.97309 28.4927 10.5472 26.9959 10.952 25.9001C11.2468 25.1022 11.2962 24.1963 11.5657 23.5283C11.7372 23.1031 12.0638 22.7415 12.2266 22.3423C12.4386 21.8229 12.4334 21.341 12.6043 20.8718C12.8462 20.8243 12.9525 20.8125 13.1708 20.7769C13.6061 21.387 14.2489 22.1915 14.3038 23.1488C14.3459 23.8839 14.1061 24.6066 14.1621 25.2834C14.2654 26.5297 14.9308 27.6974 15.2479 28.7937C15.3792 29.2475 15.2789 29.7 15.2951 30.1694C15.3187 30.8513 15.6925 31.0337 15.956 31.4028C16.1184 31.6301 16.2001 31.754 16.3611 31.9995C16.5841 31.8599 16.8096 31.6675 16.9747 31.5252C16.8036 31.2999 16.6818 31.1478 16.4989 30.8454C17.0787 30.5715 17.6551 30.9312 18.1747 30.8335C18.5406 30.6437 18.9517 30.3705 19.2133 30.1694C19.3601 30.0565 19.5366 29.9187 19.6854 29.7899C19.7759 29.7115 19.8631 29.6208 19.9569 29.5417C20.0984 29.4223 20.0231 29.3671 19.9434 29.314C19.8546 29.255 19.716 29.302 19.6218 29.3206C19.3785 29.3689 19.1521 29.4721 18.911 29.5287C18.7631 29.5633 18.6089 29.5753 18.458 29.5527C18.2542 29.5222 17.6602 29.3447 17.2778 29.2207C16.1843 28.8659 16.2359 26.4859 16.3336 25.0462C16.3747 24.442 16.1293 23.5897 16.1449 22.8641C16.1535 22.4579 16.224 22.1153 16.1921 21.8679C16.1207 21.316 15.7399 20.7729 15.6728 20.3974C15.6588 20.3194 15.7278 20.2397 15.72 20.1602C15.6897 19.8552 15.5148 19.4969 15.4367 19.164C15.3435 18.7665 15.2401 18.3788 15.2007 18.073C15.2953 18.0924 15.4249 18.1708 15.6255 18.1204C15.448 17.2188 15.0055 16.0326 14.9175 14.8947C14.8784 14.3908 14.9091 13.8095 14.8231 13.3293C14.7474 12.9071 14.5469 12.5977 14.7758 12.2857C15.7402 13.2616 16.7109 14.231 17.7499 15.1319C17.8994 15.0054 18.1052 14.7616 18.4108 14.705C18.7142 14.8591 18.9761 15.0695 19.2244 15.3006C19.4334 15.4951 19.6396 15.6948 19.894 15.829C20.0755 15.9248 20.2173 16.0641 20.3677 16.2016C20.414 16.2439 20.5932 16.3779 20.6244 16.2485C20.6421 16.1753 20.5814 16.1063 20.5351 16.0579C20.4989 16.02 20.3848 15.9458 20.425 15.883C20.4604 15.8276 20.4918 15.883 20.4918 15.883C20.4918 15.883 20.665 16.0688 20.7751 16.1716C20.8206 16.214 20.8765 16.2 20.9195 16.1624C20.9385 16.1458 20.9519 16.1116 20.971 16.0984C20.9919 16.084 21.0177 16.0939 21.0431 16.092C21.0925 16.0882 21.1452 16.0972 21.181 16.0555C21.2121 16.0192 21.23 15.9448 21.2943 15.9542C21.3219 15.9581 21.3731 15.9976 21.4203 15.9383C21.5018 15.8359 21.3679 15.6706 21.3116 15.5909C21.3105 15.5895 21.337 15.6157 21.3361 15.6141Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                            </a>
                            <div
                                width="[object Object]"
                                className="View__Styled-kNNgRd gYxvIP"
                            >
                                <a
                                    href="/"
                                    className="Header___StyledView2-esoFdH jFdNvB"
                                >
                                    <div
                                        height="32px"
                                        className="Icon__Styled-dKPIfv gVOJxh"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="151"
                                            height="24"
                                            viewBox="0 0 151 24"
                                        >
                                            <g fill="none" fillRule="evenodd">
                                                <path
                                                    fill="white"
                                                    d="M19.674.871V23.22h3.377v-9.576h4.63v-3.196h-4.63V4.042h5.382V.872zM36.019 15.293l-1.29-9.305-1.288 9.305h2.578zm3.412 0l1.098 7.926h-3.413l-.656-4.743h-3.449l-.668 4.743h-3.4l1.097-7.9L32.427.87h4.63l2.374 14.422zM41.933 23.219h3.377V.871h-3.377zM51.166 4.042v6.405h.775c.47 0 .792-.03.967-.09.612-.232.919-.709.919-1.43V5.575c0-1.023-.49-1.534-1.468-1.534h-1.193zM47.788.872h4.917c3 0 4.499 1.568 4.499 4.704v3.35c0 1.968-.887 3.265-2.661 3.892l3.794 10.401h-3.699l-3.043-9.833-.43.064v9.769h-3.377V.871zM61.138.871l2.303 8.713L65.744.87h3.58l-4.093 12.67-.096.283v9.395h-3.377v-9.395l-.107-.284L57.558.871zM80.131 18.927c0 3.128-1.619 4.696-4.857 4.704-3.23 0-4.845-1.567-4.845-4.704V5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v3.003h-3.377V5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.455.503-1.455 1.508v13.674c0 1.006.489 1.508 1.467 1.508.987 0 1.48-.502 1.48-1.508v-5.245h-1.468v-3.183h4.845v8.428zM88.397 5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.456.503-1.456 1.508v13.674c0 1.006.49 1.508 1.468 1.508.986 0 1.48-.502 1.48-1.508V5.253zm3.377 13.674c0 3.128-1.62 4.696-4.857 4.704-3.23 0-4.845-1.567-4.845-4.704V5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v13.674zM123.683 5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.456.503-1.456 1.508v13.674c0 1.006.49 1.508 1.468 1.508.987 0 1.48-.502 1.48-1.508V5.253zm3.377 13.674c0 3.128-1.619 4.696-4.857 4.704-3.23 0-4.845-1.567-4.845-4.704V5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v13.674zM97.33 4.042v15.994h1.48c.979 0 1.468-.503 1.468-1.508V5.576c0-1.023-.49-1.534-1.468-1.534h-1.48zM93.955.872h5.202c3 0 4.5 1.568 4.5 4.704v12.952c0 3.119-1.572 4.683-4.714 4.691h-4.988V.871zM109.212 13.643v6.393h1.48c.978 0 1.468-.503 1.468-1.508V15.15c0-.713-.307-1.181-.92-1.405-.174-.068-.497-.103-.966-.103h-1.062zm0-9.601v6.405h1.062c.47 0 .792-.03.967-.09.612-.232.919-.709.919-1.43V5.575c0-1.023-.49-1.534-1.468-1.534h-1.48zm-3.377-3.17h5.203c2.999 0 4.499 1.568 4.499 4.704v3.35c0 1.47-.617 2.51-1.85 3.12 1.233.61 1.85 1.645 1.85 3.105v3.377c0 3.119-1.572 4.683-4.714 4.691h-4.988V.871zM140.644 5.253c0-3.127 1.615-4.69 4.845-4.69 3.237 0 4.857 1.563 4.857 4.69v3.003h-3.378V5.253c0-1.005-.489-1.508-1.467-1.508h-.024c-.971 0-1.456.503-1.456 1.508v2.024c0 .996 1.054 2.216 3.162 3.66 2.108 1.435 3.163 3.157 3.163 5.168v2.822c0 3.137-1.616 4.704-4.845 4.704-3.238-.008-4.857-1.576-4.857-4.704v-3.003h3.377v3.003c0 1.006.493 1.508 1.48 1.508.978 0 1.467-.502 1.467-1.508v-2.551c0-1.083-1.054-2.346-3.162-3.79-2.108-1.434-3.162-3.178-3.162-5.232v-2.1zM129.001 5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v3.003h-3.377V5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.456.503-1.456 1.508v2.024c0 .996 1.054 2.216 3.163 3.66 2.108 1.435 3.162 3.157 3.162 5.168v2.822c0 3.137-1.615 4.704-4.845 4.704-3.238-.008-4.857-1.576-4.857-4.704v-3.003h3.377v3.003c0 1.006.493 1.508 1.48 1.508.978 0 1.468-.502 1.468-1.508v-2.551c0-1.083-1.055-2.346-3.163-3.79-2.108-1.434-3.162-3.178-3.162-5.232v-2.1z"
                                                />
                                                <path
                                                    fill="white"
                                                    d="M8.98 4.11c-.012-.005-.118-.076-.132-.068-.02.011-.046.07-.058.091-.045.075-.074.146-.115.224a.754.754 0 0 1-.035.06c-.008.013-.019.039-.033.041-.012.003-.018-.012-.024-.023a.648.648 0 0 1-.106-.292 1.512 1.512 0 0 1-.003-.155c.003-.09.012-.18.025-.268.003-.016.023-.184.034-.184.106.002.176-.036.207-.121.039.21.068.433.241.486l-.002.21M5.367 13.85l-.814-.716c.025-.149.135-.33.345-.328-.14.235.035.28.093.295-.004.122.043.183.144.175.023.08.01.2.198.163-.007.193.127.173.249.14.063.113-.083.254-.215.27m10.584-2.363l-.057-.084-.097-.13c-.03-.042-.053-.09-.086-.13a3.211 3.211 0 0 0-.067-.077l-.024-.026a.813.813 0 0 0-.184-.137c-.203-.105-.464-.109-.655-.204-.259-.13-.537-.409-.723-.578-.216-.197-.469-.4-.655-.579-.126-.122-.24-.255-.367-.376-.08-.078-.168-.148-.248-.226-.078-.078-.145-.168-.224-.246a.765.765 0 0 0-.171-.128c-.046-.024-.055-.075-.081-.115a.796.796 0 0 0-.08-.102c-.053-.058-.135-.106-.175-.172-.119-.195-.203-.408-.333-.598a1.802 1.802 0 0 0-.055-.077c-.01-.011-.058-.057-.058-.07.01-.219-.154-.36-.206-.578-.02-.084.021-.198 0-.307-.022-.111-.123-.206-.138-.306-.025-.16.028-.312-.023-.47a1.092 1.092 0 0 0-.246-.399.462.462 0 0 0-.145-.118c-.3-.157-.352-.56-.55-.817.14-.343.232-.62.427-.828.178-.022.48.049.606-.125.056-.129-.035-.213-.035-.306.008-.146.088-.242 0-.34-.006-.008.052-.06.059-.065.044-.031.102-.05.131-.099.042-.07-.006-.117-.052-.166-.049-.052-.101-.095-.145-.15a.517.517 0 0 1-.059-.092c-.013-.027-.04-.078-.037-.109.014-.224.142-.232.138-.408a.57.57 0 0 0-.064-.227c-.072-.142-.204-.257-.331-.35a1.209 1.209 0 0 0-.468-.206c-.227-.045-.458-.097-.692-.086-.327.014-.605.184-.808.432a1.35 1.35 0 0 0-.29.811c-.006.256.1.457.069.647-.068.003-.178.115-.104.238-.696.085-.353 1.06-.034 1.361-.192.208-.362.437-.551.647C6.44 3.748 5.055 2.245 4.135.285c-.029.38.088.837.212 1.157-.218-.091-.359-.33-.419-.545-.163.87.577 1.574.366 1.706-.133-.041-.311-.264-.389-.362-.212 1.316.506 1.489.471 2.297-.038.142-.224.047-.314.073.258.527.665.942 1.244 1.153-.22.224-.43.34-.994.319.51.641 1.506.82 2.166 1.314-.597.093-1.166.34-1.89.193.288.539 1.08.601 1.77.607.01.056-.477.454-1.011.442.335.243.66.335 1.073.38-.116.527-.402 1.11-.562 1.679-.082.29-.082.596-.138.868-.075.36-.31.544-.448.8-.135-.055-.316-.008-.422.062-.136.09-.259.188-.28.36l-.223-.17-.311-.32-.093.01-.411-.317v.002l-.332-.257-.525-.03-.171.262c-.718 1.055-1.422 2.076-2.125 3.154l.327.26-.04.048.096.077.04-.049.043.034c1.181.943 2.416 1.855 3.6 2.795l.013.012-.043.049.094.08.041-.048.304.268c.057-.04.133-.089.172-.114.073-.006.125-.005.28-.009.014 0 .109-.157.121-.175l.124-.177.24-.35c.157-.226.313-.454.471-.68.157-.222.312-.447.468-.67.159-.229.324-.454.476-.687.095-.144.214-.274.3-.423.04-.07.09-.162.054-.238-.04-.084-.127-.13-.199-.191l-.397-.305-.417-.43-.125.013-.507-.39c.259-.073.425-.49.299-.742.086-.247.092-.413.109-.608.031-.37-.022-.74.099-.89.155.018.4.022.607.035.202-.919.507-1.587.81-2.365.168-.081.336-.145.413-.175.037.89-.293 1.567-.396 2.234-.088.57-.085 1.292-.172 1.837.086.063.217.075.314.094.03.641-.202 1.337-.314 1.948.174.014.183-.137.31-.17.177 1.12-.87 1.857-.965 3.267-.055.81.016 1.582-.069 2.314-.05.427-.244.683-.379.919-.206.361-.073.434-.207 1.395.211.03.396.086.62.102.023-.216.01-.485.035-.68.524.061.793.666 1.378.748.161.023.403.012.586 0 .188-.012.39 0 .565-.086.266-.13-.214-.298-.312-.33a4.64 4.64 0 0 0-.24-.071c-.065-.018-.16-.024-.22-.057-.178-.1-.236-.3-.379-.51-.118-.175-.287-.321-.344-.443-.405-.863.014-1.936.31-2.723.215-.572.25-1.222.448-1.701.125-.305.363-.565.482-.85.155-.373.15-.72.276-1.056.176-.034.254-.042.413-.068.318.438.787 1.015.827 1.702.03.527-.144 1.045-.103 1.531.075.894.56 1.732.792 2.518.096.326.023.65.034.987.018.49.29.62.483.885.118.163.178.252.295.428.163-.1.328-.238.448-.34-.125-.162-.213-.27-.347-.488.423-.196.844.062 1.223-.008.267-.137.567-.333.758-.477.107-.08.236-.18.345-.272.066-.056.13-.121.198-.178.103-.086.048-.125-.01-.163-.065-.043-.166-.01-.235.004-.177.035-.343.109-.518.15a.896.896 0 0 1-.331.017c-.149-.022-.582-.15-.861-.238-.799-.255-.76-1.962-.69-2.995.03-.434-.149-1.045-.137-1.566.006-.291.057-.537.034-.714-.052-.396-.33-.786-.379-1.055-.01-.056.04-.113.035-.17-.023-.22-.15-.476-.207-.715-.068-.285-.144-.563-.172-.783.069.014.163.07.31.034-.13-.646-.453-1.497-.517-2.314-.029-.361-.006-.778-.069-1.123-.055-.303-.202-.525-.035-.748.704.7 1.413 1.395 2.171 2.041.11-.09.26-.265.482-.306.222.11.413.262.594.427.153.14.303.283.489.38.132.068.236.168.346.267.033.03.164.126.187.033.013-.052-.031-.102-.065-.136-.027-.027-.11-.08-.08-.126.025-.04.048 0 .048 0s.127.134.207.207c.033.03.074.02.105-.006.014-.012.024-.037.038-.046.015-.01.034-.003.053-.005.036-.003.074.004.1-.026.023-.026.036-.08.083-.073.02.003.057.031.092-.011.06-.074-.038-.192-.08-.25l.018.017"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </a>
                            </div>
                            <div
                                width="50px"
                                display="flex"
                                className="View__Styled-kNNgRd Fwcpf"
                            />
                            <a
                                className="Link__StyledLink-kLbdzo ibaoyu HeaderLink___StyledLink-dIJhxw eVzEEJ  home"
                                fontFamily="Open Sans"
                                title="Community"
                                href="/community/feed"
                                target="_self"
                            >
                                Community
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo ibaoyu HeaderLink___StyledLink-dIJhxw eVzEEJ  jobs"
                                fontFamily="Open Sans"
                                title="Jobs"
                                href="/jobs/filter"
                                target="_self"
                            >
                                Jobs
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo ibaoyu HeaderLink___StyledLink-dIJhxw eVzEEJ  advice"
                                fontFamily="Open Sans"
                                title="Advice"
                                href="/advice"
                                target="_self"
                            >
                                Advice
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo ibaoyu HeaderLink___StyledLink-dIJhxw eVzEEJ  events"
                                fontFamily="Open Sans"
                                title="Events"
                                href="/events"
                                target="_self"
                            >
                                Events
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo ibaoyu HeaderLink___StyledLink-dIJhxw eVzEEJ  reviews"
                                fontFamily="Open Sans"
                                title="Reviews"
                                href="/company-reviews"
                                target="_self"
                            >
                                Reviews
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo bUUeTB HeaderLink___StyledLink-dIJhxw eVzEEJ "
                                fontFamily="Open Sans"
                                title="For Employers"
                                href="/employers"
                                target="_self"
                            >
                                For For Employers
                            </a>
                            <div
                                width="50px"
                                display="flex"
                                className="View__Styled-kNNgRd Fwcpf"
                            />
                        </div>
                        <div
                            width="100%"
                            className="View__Styled-kNNgRd eysfBO"
                        >
                            <a
                                className="Link__StyledLink-kLbdzo jbOdwd HeaderLink___StyledLink-dIJhxw eVzEEJ "
                                fontFamily="Open Sans"
                                title="Community"
                                href="/community/feed"
                                target="_self"
                            >
                                Community
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo jbOdwd HeaderLink___StyledLink-dIJhxw eVzEEJ "
                                fontFamily="Open Sans"
                                title="Jobs"
                                href="/jobs/filter"
                                target="_self"
                            >
                                Jobs
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo jbOdwd HeaderLink___StyledLink-dIJhxw eVzEEJ "
                                fontFamily="Open Sans"
                                title="Advice"
                                href="/advice"
                                target="_self"
                            >
                                Advice
                            </a>
                            <a
                                className="Link__StyledLink-kLbdzo jbOdwd HeaderLink___StyledLink-dIJhxw eVzEEJ "
                                fontFamily="Open Sans"
                                title="Events"
                                href="/events"
                                target="_self"
                            >
                                Events
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <img
                    className="error-image"
                    src="https://d207ibygpg2z1x.cloudfront.net/image/upload/v1573848275/SVGs/404girl.svg"
                    alt="404 error"
                />

                <p className="error-description">
                    Oops, that page does not exist. Please try again.
                </p>
            </div>
        </div>
    );
}
